import "./loading.scss";

export const Loading: React.FC = () => {
  return (
    <div className="wrapper">
      <div className="track">
        <div className="puckGroup puckGroupLeft">
          <img
            src="./img/pink-puck.svg"
            alt=""
            className="puck"
            draggable={false}
          />
        </div>
        <div className="puckGroup puckGroupRight">
          <img
            src="./img/blue-puck.svg"
            alt=""
            className="puck"
            draggable={false}
          />
        </div>
      </div>
    </div>
  );
};
